<template>
    <b-modal
        id="copy-school-modal"
        ref="copy-school-modal"
        :title="$t('school.copy_school')"
        :ok-title="$t('common.save')"
        @ok="save"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        modal-class="apprentice-default-modal"
        @show="show()">
        <b-form-group
            :label="$t('school.copy_of')"
            label-for="school">
            <design-2021-apprentice-multiselect-component
                id="school"
                v-model="school"
                label="text"
                :options="schools"
                :show-labels="false"
                :multiple-select="false">
            </design-2021-apprentice-multiselect-component>
        </b-form-group>

        <b-form-group
            :label="$t('common.name')"
            label-for="name">
            <b-form-input
                id="name"
                v-model="name"
                required
                :placeholder="$t('common.name')"></b-form-input>
        </b-form-group>

        <b-form-group
            label="Type:"
            label-for="type">
            <design-2021-apprentice-multiselect-component
                v-model="selected_type"
                :options="schoolTypes"
                :show-labels="false"
                track-by="key"
                label="label"
                :multiple-select="false">
            </design-2021-apprentice-multiselect-component>
        </b-form-group>

        <b-form-group
            :label="$t('common.street')"
            label-for="street">
            <b-form-input
                id="street"
                v-model="street"
                :placeholder="$t('common.street')"></b-form-input>
        </b-form-group>

        <b-form-group
            :label="$t('common.house_number')"
            label-for="streetnumber">
            <b-form-input
                id="streetnumber"
                v-model="streetnumber"
                :placeholder="$t('common.house_number')"></b-form-input>
        </b-form-group>

        <b-form-group
            :label="$t('common.city')"
            label-for="city">
            <b-form-input
                id="city"
                v-model="city"
                :placeholder="$t('common.city')"></b-form-input>
        </b-form-group>

        <b-form-group
            :label="$t('common.postal_code')"
            label-for="zipcode">
            <b-form-input
                id="zipcode"
                v-model="zipcode"
                :placeholder="$t('common.postal_code')"></b-form-input>
        </b-form-group>

        <b-form-group
            :label="$t('common.phone')"
            label-for="phone">
            <b-form-input
                id="phone"
                v-model="phone"
                :placeholder="$t('common.phone')"></b-form-input>
        </b-form-group>
    </b-modal>
</template>

<script>
import { ords } from '../../../app';
import Design2021ApprenticeMultiselectComponent from '../../common/design-2021-apprentice-multiselect-component.vue';

export default {
    name: 'design-2021-school-index-copy-school-modal-component',

    components: { Design2021ApprenticeMultiselectComponent },

    props: ['schoolsIn', 'schoolTypesIn'],

    data() {
        return {
            school: null,
            name: '',
            selected_type: null,
            city: '',
            street: '',
            streetnumber: '',
            zipcode: '',
            phone: '',
        };
    },

    methods: {
        save() {
            let data = {
                school: this.school.value,
                name: this.name,
                school_type: this.selected_type.key,
                city: this.city,
                street: this.street,
                streetnumber: this.streetnumber,
                zipcode: this.zipcode,
                phone: this.phone,
            };

            this.alert.saving();

            this.axios
                .post(this.routes.schoolCopy(this.school.value), data)
                .then((response) => {
                    ords.use('school').add(response.data);

                    this.alert.success();
                })
                .catch(() => {
                    this.alert.ajaxError(error);
                });
        },

        show() {
            this.id = '';
            this.name = '';
            this.selected_type = null;
            this.city = '';
            this.street = '';
            this.streetnumber = '';
            this.zipcode = '';
            this.phone = '';
        },
    },
    computed: {
        schools() {
            return this.schoolsIn.map((school) => {
                return {
                    value: school.id,
                    text: school.id + ' ' + school.name,
                };
            });
        },
        schoolTypes() {
            return Object.keys(this.schoolTypesIn).map((key) => ({
                key: key,
                label: this.schoolTypesIn[key],
            }));
        },
    },
};
</script>

<style scoped></style>
